import { Injectable } from "@angular/core";
import { DefaultService } from "src/app/core/services/default.service";
import {
  IRegion,
  IRegionData,
  IRegionInsert,
  IRegionUpdate,
} from "../models/regions.interface";
import { ColDef } from "ag-grid-community";
import { ResidentActionsComponent } from "src/app/shared/datatable/actions/resident-actions.component";
import { EditRegionFormComponent } from "../pages/regions/edit-region-form/edit-region-form.component";
import { E_ACTIONS, E_SUBJECT } from "@core/enums/Permission.enum";

@Injectable({
  providedIn: "root",
})
export class RegionService extends DefaultService<
  IRegionData,
  IRegionInsert,
  IRegionUpdate
> {
  getServiceKey(): string {
    return "RegionService";
  }

  override columnDefs: ColDef[] = [
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.ID",
      field: "id",
      maxWidth: 100,
    },
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.NAME",
      field: "name",
    },
    {
      headerName: "GEOGRAPHY.MODAL_BUTTON.SOATO",
      field: "soato",
    },
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.CADASTRAL_CODE",
      field: "cadastralCode",
    },
    {
      field: "actions",
      headerName: "TOOLS.RESIDENTS.TABLE_HEADERS.ACTION",
      cellRenderer: ResidentActionsComponent<IRegion>,
      cellRendererParams: {
        // handleDelete: this.onDelete.bind(this),
        handleEdit: this._ability.can(E_ACTIONS.DELETE, E_SUBJECT.REGIONS)
          ? this.onEdit.bind(this)
          : null,
        // handleGoLink: this.onHandleGoLink.bind(this),
      },
      suppressNavigable: true,
      cellClass: "no-border",
      pinned: "right",
      minWidth: 80,
      maxWidth: 80,
    },
  ];

  constructor() {
    super(`user-service/regions`);
  }

  onDelete(data: IRegion) {
    this.selectedRow.set(data);
    this._confirmationDialogService
      .open({
        title: "GEOGRAPHY.REGIONS.MODAL.DELETE_MODAL",
        message: "GEOGRAPHY.REGIONS.MODAL.DELETE_MODAL_SUBTITLE",
      })
      .then((res) => {
        if (res) {
          this.subscriptions = this.delete(data.id).subscribe(() => {
            this._toastService.success("TOAST.TOAST_DELETE");
            this.subscriptions.unsubscribe();
          });
        }
      });
  }

  onEdit(data: IRegion) {
    this.selectedRow.set(data);
    this._modalService.open({
      component: EditRegionFormComponent,
      title: "GEOGRAPHY.REGIONS.MODAL.UPDATE_MODAL",
    });
  }
}
